import _ from 'lodash';
import React from 'react';
import RouteNavItem from 'components/RouteNavItem';
import NavLink from 'components/NavLink';
import { Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';

const NavList = ({ navItems }) => {
  if (!navItems.length) return null;

  const items = navItems.map(navItem => {
    const badge = _.has(navItem, 'badgeType') ? navItem.badgeType : null;
    return (
      <RouteNavItem key={navItem.id} href={navItem.url}>
        <NavLink
          title={navItem.title}
          glyphIcon={navItem.glyphIcon}
          awesomeIcon={navItem.awesomeIcon}
          badge={badge}
        />
      </RouteNavItem>
    );
  });

  return <Nav>{items}</Nav>;
};

NavList.propTypes = {
  navItems: PropTypes.array.isRequired
};

export default NavList;



// WEBPACK FOOTER //
// ./src/components/MainMenu/NavList.js